module.exports = __webpack_public_path__ + "img/xa2.d9e62e42.jpg";